import { render, staticRenderFns } from "./ServiceTypeList.vue?vue&type=template&id=c2773a1e&scoped=true"
import script from "./ServiceTypeList.vue?vue&type=script&lang=ts"
export * from "./ServiceTypeList.vue?vue&type=script&lang=ts"
import style0 from "./ServiceTypeList.vue?vue&type=style&index=0&id=c2773a1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2773a1e",
  null
  
)

export default component.exports